module.exports = __webpack_public_path__ + "img/system_zasilania_wody_01.4fc54e83.jpg";